export const Utils = {
  dialogOnCloseReasons: ["escapeKeyDown", "backdropClick"],
  limit: {
    digits: {
      aadhaar_number: 12,
      address: 50,
      company_name: 30,
      gst_number: 15,
      mobile: 10,
      name: 30,
      nominee_name: 30,
      open_text_field: 50,
      pan_number: 10,
      pincode: 6,
      registration_number: 11,
      vehicle_chassis_number: 17,
      vehicle_engine_number: 14,
    },
    vehicle_engine_number: {
      min: 10,
      max: 14,
    },
    vehicle_chassis_number: {
      min: 12,
      max: 17,
    },
    aadhaar_number: {
      min: 12,
      max: 14
    }
  },
  regex: {
    name: /^([a-zA-Z]{1,}\s[a-zA-Z]{1,}\s?([a-zA-Z]{1,})?)$/,
    nominee_name: /^([a-zA-Z]{1,}\s[a-zA-Z]{1,}\s?([a-zA-Z]{1,})?)$/,
    pan_number: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
    aadhaar_number: /^([0-9]{4}[0-9]{4}[0-9]{4}$)|([0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|([0-9]{4}-[0-9]{4}-[0-9]{4}$)/
  },
  support: {
    mobile: "+91 9871115834 / 8800502077",
  },
  s3Bucket: {
    url: "https://toffee-cdn-qa.s3.ap-south-1.amazonaws.com"
  },
  url: {
    assurance: "http://qa-assurance.toffcover.com/product/buy/vehicle",
    insurance: "https://qa.toffeeinsurance.com/dealer/toffee-distributor/home"
  }
};
